import lodash from "lodash";
function generateId(prefix = "") {
  const key = Math.random().toString(36).substr(2, 5);
  return `${key}${lodash.uniqueId(prefix)}`;
}
export {
  generateId
};
//# sourceMappingURL=generateRandomId.js.map
